import rdsMySqlCharts from './cloudTemplates/aws/rds.mysql.config.js';
import lambdaCharts from './cloudTemplates/aws/lambda.config.js';
import elastiCacheCharts from './cloudTemplates/aws/elasticache.config.js';

const awsTemplates = {
  RDS: {
    overview: {
      cards: {
        template: rdsMySqlCharts().cardComponents,
      },
      table: {
        show: true,
        width: '98%',
      },
    },
    subscriptionId: {
      cards: {
        template: rdsMySqlCharts().cardComponents,
      },
      graphs: {
        template: rdsMySqlCharts().lineChartsSubscriptionPage,
      },
      table: {
        show: true,
        width: '98%',
      },
    },
    databases: {
      graphs: {
        template: rdsMySqlCharts().lineChartsDatabasePage,
      },
    },
  },
  LAMBDA: {
    overview: {
      graphs: {
        template: lambdaCharts().lineChartsOverviewPage,
      },
    },
  },
  ELASTICACHE: {
    overview: {
      graphs: {
        template: elastiCacheCharts().lineChartsOverviewPage,
      },
    },
    subscriptionId: {
      graphs: {
        template: elastiCacheCharts().lineChartsSubscriptionPage,
      },
    },
  },
};

export default awsTemplates;
